import { Box, Flex, Input } from "@chakra-ui/react";
import { Icons, Typography } from "@reconvert/react-ui-component";
import React from "react";
import { useTranslation } from "react-i18next";

interface ProductSkuSelectorProps {
  sku: string;
  setSkuValue: (data: { value: string }) => void;
  fieldError?: string;
}

const ProductSkuSelector = ({ sku, setSkuValue, fieldError }: ProductSkuSelectorProps) => {
  const { t } = useTranslation();

  return (
    <Box mt={2}>
      <Flex gap={1} flexDirection={"column"}>
        <Typography color={"#6A7381"} width={"max-content"} bg={"var(--Natural-100, #F9FAFC)"} variant="small">
          {t("SKU")}
        </Typography>
        <Input value={sku} onChange={e => setSkuValue({ value: e.target.value })} isInvalid={!!fieldError} />
        {fieldError && (
          <Flex alignItems="center" gap="4px">
            <Icons.CloseFilled width="12px" height="12px" color="error.700" />
            <Typography variant="small" color="red.500" mt={0.5}>
              {fieldError}
            </Typography>
          </Flex>
        )}
      </Flex>
    </Box>
  );
};

export default ProductSkuSelector;
